import { ContainerResponseDto } from '@planning/app/api'
import { containerService } from '@planning/services'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetContainerByIdQuery implements IQueryMessage {
  static type = 'GetContainerByIdQuery'
  type = GetContainerByIdQuery.type

  constructor(public id: number) {}

  getKey = () => {
    return JSON.stringify(this)
  }
}

export const getContainerByIdQueryHandler: IQueryHandler<
  GetContainerByIdQuery,
  IEvent<ContainerResponseDto>
> = async query => {
  const data = await containerService.getByIds([query.id])

  return new Event(GetContainerByIdQuery.type, data[0])
}
